/**
 * Утилита для работы с типами важных дат (клиентская часть)
 * Использует общий файл shared/dateTypes.json для синхронизации с сервером
 */

import dateTypesData from '../../../shared/dateTypes.json';

const DATE_TYPES = dateTypesData.DATE_TYPES;
const DATE_TYPE_LABELS = dateTypesData.DATE_TYPE_LABELS;
const DATE_TYPE_COLORS = dateTypesData.DATE_TYPE_COLORS;

/**
 * Получить массив всех типов дат с лейблами и цветами
 * @returns {Array<{value: string, label: string, color: string}>}
 */
const getAllDateTypes = () => {
  return Object.values(DATE_TYPES).map(value => ({
    value,
    label: DATE_TYPE_LABELS[value],
    color: DATE_TYPE_COLORS[value]
  }));
};

/**
 * Список всех доступных типов важных дат для использования в компонентах
 */
export const dateTypes = getAllDateTypes();

/**
 * Типы дат ухода: требуют наличия даты Start Work у таланта.
 * Значение — лейбл для сообщений об ошибке.
 */
export const DEPARTURE_DATE_TYPES = {
  [DATE_TYPES.FIRED]: DATE_TYPE_LABELS[DATE_TYPES.FIRED],
  [DATE_TYPES.LEFT]: DATE_TYPE_LABELS[DATE_TYPES.LEFT]
};

/**
 * Получить лейбл типа даты по значению
 * @param {string} value - Значение типа даты
 * @returns {string} - Лейбл типа даты или сам value если не найден
 */
export const getDateTypeLabel = (value) => {
  return DATE_TYPE_LABELS[value] || value;
};

/**
 * Получить объект типа даты по значению
 * @param {string} value - Значение типа даты
 * @returns {object|null} - Объект типа даты или null если не найден
 */
export const getDateType = (value) => {
  return dateTypes.find(type => type.value === value) || null;
};

/**
 * Проверить, существует ли тип даты
 * @param {string} value - Значение типа даты
 * @returns {boolean} - true если тип существует
 */
export const isValidDateType = (value) => {
  return Object.values(DATE_TYPES).includes(value);
};

/**
 * Получить типы дат для select компонента
 * @returns {array} - Массив объектов для react-select
 */
export const getDateTypesForSelect = () => {
  return dateTypes;
};

/**
 * Получить цвет типа даты по значению
 * @param {string} value - Значение типа даты
 * @returns {string} - HEX цвет типа даты или серый цвет по умолчанию
 */
export const getDateTypeColor = (value) => {
  return DATE_TYPE_COLORS[value] || '#6B7280';
};

/**
 * Получить массив всех типов дат с лейблами и цветами
 * @returns {Array<{value: string, label: string, color: string}>}
 */
export const getDateTypesWithColors = () => {
  return Object.values(DATE_TYPES).map(value => ({
    value,
    label: DATE_TYPE_LABELS[value],
    color: DATE_TYPE_COLORS[value]
  }));
};

/**
 * Экспорт объекта цветов для использования в компонентах
 */
export { DATE_TYPE_COLORS };
